import React from 'react'
import { Outlet } from 'react-router-dom'

const WithOutNavBar = () => {
  return (
    <Outlet />
  )
}

export default WithOutNavBar